import React, { useEffect, useState } from "react";
import CartSlider from "../Navbar/cartSlider";
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/footer";
import FooterDoodles from "../Footer/footerDoodles";
import icons from "../../icons.config";
import { useNavigate } from "react-router-dom";
import CouponsPopUp from "./couponsPopUp";
import { useDispatch, useSelector } from "react-redux";
import { fetchCartItems } from "../../Providers/cartProvider";
import { removeCouponAPI } from "../../Providers/couponsProvider";

const Cart = () => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated || false);

  const {
    cartItems,
    subTotal,
    discount,
    couponCode,
  } = useSelector((state) => state.cartItems);

  const hasSelectedItems = cartItems.some((item) => item.isSelected);
  const hasCartItems = cartItems.length > 0;

  useEffect(() => {
    if (isAuthenticated) {
      fetchCart();
    }
  }, [isAuthenticated]);

  const fetchCart = async () => {
    dispatch(fetchCartItems());
    console.log("Cart items:", cartItems);
  };

  const handleCheckout = () => {
    if (hasSelectedItems) {
      navigate("/checkout");
    }
  };

  const goToLogin = () => {
    navigate("/login");
  };

  const isCouponButtonDisabled = !hasCartItems || !hasSelectedItems;

  return (
    <>
      <div className="overflow-x-hidden">
        <Navbar />
        {isPopupOpen && (
          <div className="fixed inset-0 bg-tertiary bg-opacity-50 z-40"></div>
        )}

        {!isAuthenticated ? (
          <div className="min-h-screen bg-tertiary flex flex-col items-center justify-center space-y-6 pt-20 pb-10 px-4">
            <img
              src={icons.emptyCart}
              alt="Login required"
              className="w-32 h-32 opacity-80 transform transition-transform duration-500 hover:rotate-12"
            />
            <h2 className="text-2xl font-outfit text-hcolor font-medium text-center">
              Please Log In
            </h2>
            <p className="text-center text-gray-600 font-outfit text-base max-w-md">
              Sign in to view your cart, apply coupons, and proceed to checkout with ease!
            </p>
            <button
              onClick={goToLogin}
              className="border-2 py-3 px-8 text-hcolor font-outfit font-medium bg-white hover:bg-hcolor hover:text-primary2 transition-all duration-300 rounded-md"
            >
              Log In
            </button>
            <p className="text-sm text-gray-500">
              Don’t have an account?{" "}
              <span
                onClick={() => navigate("/signup")}
                className="text-hcolor cursor-pointer hover:underline"
              >
                Sign Up
              </span>
            </p>
          </div>
        ) : (
          <div className="lg:px-32 w-full bg-tertiary pt-36 relative">
            <div className="absolute -top-8 -right-1 lg:-top-14 lg:-right-20 z-10">
              <img
                src={icons.trendCircles}
                alt="Doodle Left"
                className="w-44 md:w-60 lg:w-4/5"
              />
            </div>
            <h2 className="mb-4 text-center font-outfit text-primary1 text-3xl font-light">
              Your Shopping Cart
            </h2>
            <div className="flex flex-col md:flex-row gap-6">
              <div className="lg:w-2/3 w-full bg-tertiary">
                <CartSlider />
              </div>

              <div className="lg:w-1/3 w-full bg-tertiary p-4 rounded shadow-md text-primary1">
                <h3 className="text-xl font-outfit font-light mb-4">Order Summary</h3>

                <div className="relative w-full">
                  <label className="block mb-2 text-hcolor font-poppins font-normal">
                    Enter Coupon Code
                  </label>
                  <input
                    type="text"
                    id="coupon"
                    placeholder="Enter Coupon Code"
                    value={couponCode || ""}
                    readOnly
                    onClick={async () => {
                      if (couponCode && !isCouponButtonDisabled) {
                        await removeCouponAPI();
                        dispatch(fetchCartItems());
                      } else if (!isCouponButtonDisabled) {
                        setPopupOpen(true);
                      }
                    }}
                    className="w-full p-2 border rounded cursor-pointer text-hcolor font-poppins font-normal"
                  />
                  <button
                    onClick={async () => {
                      if (couponCode && !isCouponButtonDisabled) {
                        await removeCouponAPI();
                        dispatch(fetchCartItems());
                      } else if (!isCouponButtonDisabled) {
                        alert("Please select a coupon first.");
                      }
                    }}
                    className={`absolute right-0 top-10 transform px-4 rounded font-poppins font-normal ${
                      isCouponButtonDisabled
                        ? "text-gray-400 cursor-not-allowed"
                        : "text-hcolor hover:text-gray-600"
                    }`}
                    disabled={isCouponButtonDisabled}
                  >
                    {couponCode ? "Remove" : "Apply"}
                  </button>

                  {isPopupOpen && (
                    <CouponsPopUp onClose={() => setPopupOpen(false)} />
                  )}
                </div>

                {Array.isArray(cartItems) && hasCartItems && (
                  <div className="py-4 border-t mt-4">
                    <div className="flex justify-between text-lg font-medium">
                      <span className="font-poppins font-normal">Subtotal</span>
                      <span className="text-hcolor font-poppins font-normal">
                        Rs.{subTotal}
                      </span>
                    </div>
                    <div className="flex justify-between text-lg font-medium">
                      <span className="font-poppins font-normal">Discount</span>
                      <span className="text-hcolor font-poppins font-normal">
                        Rs.{discount ? discount.toFixed(1) : "0.0"}
                      </span>
                    </div>
                    {discount > 0 && (
                      <p className="text-sm text-hcolor font-poppins mt-2">
                        Coupon applied! You saved Rs.{discount}.
                      </p>
                    )}
                    <p className="text-xs font-poppins">
                      Tax Included, shipping calculated at checkout.
                    </p>
                    <div className="relative group mt-6">
                      <button
                        className={`w-full py-3 font-medium transition-all duration-300 ${
                          hasSelectedItems
                            ? "bg-hcolor text-tertiary hover:bg-tertiary hover:text-hcolor border-hcolor border-2 cursor-pointer"
                            : "bg-hcolor text-tertiary border-hcolor border-2 cursor-not-allowed opacity-50"
                        }`}
                        onClick={handleCheckout}
                        disabled={!hasSelectedItems}
                      >
                        Checkout
                      </button>
                      {!hasSelectedItems && (
                        <span className="absolute left-0 -bottom-8 text-sm text-red-500 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                          Please select at least one product
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <FooterDoodles />
        <Footer />
      </div>
    </>
  );
};

export default Cart;